import { render, staticRenderFns } from "./smartChoice.vue?vue&type=template&id=64004164&scoped=true&"
import script from "./smartChoice.vue?vue&type=script&lang=js&"
export * from "./smartChoice.vue?vue&type=script&lang=js&"
import style0 from "./smartChoice.vue?vue&type=style&index=0&id=64004164&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64004164",
  null
  
)

export default component.exports